import React from 'react'
import ServiceTemplate from '../../components/ServiceTemplate'
import { Code, Smartphone, Zap, Shield } from 'lucide-react'

const WebDevelopment = () => {
  const features = [
    {
      icon: <Code className="w-6 h-6" data-component-path="client/src/pages/services/WebDevelopment.jsx" data-component-line="1:1" data-component-id="client/src/pages/services/WebDevelopment.jsx:1:1" />,
      title: 'Modern Frameworks',
      description: 'React, Next.js, Vue.js, and Angular'
    },
    {
      icon: <Smartphone className="w-6 h-6" data-component-path="client/src/pages/services/WebDevelopment.jsx" data-component-line="2:1" data-component-id="client/src/pages/services/WebDevelopment.jsx:2:1" />,
      title: 'Responsive Design',
      description: 'Perfect experience across all devices'
    },
    {
      icon: <Zap className="w-6 h-6" data-component-path="client/src/pages/services/WebDevelopment.jsx" data-component-line="3:1" data-component-id="client/src/pages/services/WebDevelopment.jsx:3:1" />,
      title: 'Performance Optimized',
      description: 'Lightning-fast load times and SEO'
    },
    {
      icon: <Shield className="w-6 h-6" data-component-path="client/src/pages/services/WebDevelopment.jsx" data-component-line="4:1" data-component-id="client/src/pages/services/WebDevelopment.jsx:4:1" />,
      title: 'Security First',
      description: 'Enterprise-grade security standards'
    },
  ]

  return (
    <ServiceTemplate
      title="Web Development"
      subtitle="Custom web applications built with cutting-edge technologies"
      description="We create stunning, high-performance web applications that drive business growth. Our expert team leverages modern frameworks and best practices to deliver scalable solutions tailored to your needs."
      features={features}
      heroImage="https://images.pexels.com/photos/546819/pexels-photo-546819.jpeg?auto=compress&cs=tinysrgb&w=1920"
    />
  )
}

export default WebDevelopment